import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AvailbleBSPositions } from 'ngx-bootstrap/positioning';

@Component({
	selector: 'app-button-icon',
	templateUrl: './button-icon.component.html',
	styleUrls: ['./button-icon.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonIconComponent {
	@Input() public isOutline = false;
	@Input() public isSecondary = false;
	@Input() public disabled = false;
	@Input() public tooltipText: string;
	@Input() public placement: AvailbleBSPositions = 'top';
	@Output() public clickHandler: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}
